export default __webpack_public_path__ + "static/media/rolands.7795d787.jpg";